import { render, staticRenderFns } from "./CabeceraAgGridPersonalizada.vue?vue&type=template&id=b7b7242a"
import script from "./CabeceraAgGridPersonalizada.vue?vue&type=script&lang=js"
export * from "./CabeceraAgGridPersonalizada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports